import { Component, OnInit, ViewChild } from '@angular/core';
import { FirebaseService } from 'src/app/services/firebase.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-manageusers',
  templateUrl: './manageusers.component.html',
  styleUrls: ['./manageusers.component.css']
})
export class ManageusersComponent implements OnInit {
  
  displayedColumns: string[] = ['uid','blank1','email','blank2', 'emailverified','blank3', 'action'];
  dataSource : MatTableDataSource<any[]>;

  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(private firebase: FirebaseService, private afs:AngularFireStorage, private router: Router) {
    this.firebase.getUsers().subscribe( res => {
      this.dataSource=new MatTableDataSource<any>(res);
      this.dataSource.paginator = this.paginator;
    });
   }

  ngOnInit(): void {
  }

  
  goDelete(id){
    this.firebase.deleteUser(id);
  }

}
